import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-2a02d348"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "marcas-container" };
const _hoisted_2 = { class: "dashboard" };
const _hoisted_3 = { class: "marcas-content" };
const _hoisted_4 = { class: "content-header" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", { class: "title" }, "Administración de Clientes", -1 /* HOISTED */));
const _hoisted_6 = { class: "header-top-controls" };
const _hoisted_7 = { class: "search-container" };
const _hoisted_8 = { class: "search-wrapper" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Nuevo Cliente", -1 /* HOISTED */));
const _hoisted_10 = { class: "filter-controls" };
const _hoisted_11 = { class: "alphabet-filter" };
const _hoisted_12 = ["onClick"];
const _hoisted_13 = { class: "table-container" };
const _hoisted_14 = { class: "marcas-table" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Documento"),
        /*#__PURE__*/ _createElementVNode("th", null, "Razón Social"),
        /*#__PURE__*/ _createElementVNode("th", null, "Ubicación"),
        /*#__PURE__*/ _createElementVNode("th", null, "Teléfono"),
        /*#__PURE__*/ _createElementVNode("th", null, "Estado"),
        /*#__PURE__*/ _createElementVNode("th", { class: "actions-column" }, "Acciones")
    ])
], -1 /* HOISTED */));
const _hoisted_16 = { key: 0 };
const _hoisted_17 = {
    colspan: "6",
    class: "text-center py-8"
};
const _hoisted_18 = { class: "loading-state" };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2 text-muted" }, "Cargando clientes...", -1 /* HOISTED */));
const _hoisted_20 = { key: 1 };
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "6",
    class: "text-center py-4 text-muted"
}, "No se encontraron clientes.", -1 /* HOISTED */));
const _hoisted_22 = [
    _hoisted_21
];
const _hoisted_23 = {
    class: "attribute-badge",
    style: { "color": "#3b82f6" }
};
const _hoisted_24 = { style: { "font-weight": "600" } };
const _hoisted_25 = { class: "actions-column" };
const _hoisted_26 = ["onClick", "title"];
const _hoisted_27 = ["onClick"];
const _hoisted_28 = ["onClick"];
const _hoisted_29 = { class: "pagination-controls" };
const _hoisted_30 = ["disabled"];
const _hoisted_31 = ["disabled"];
const _hoisted_32 = { class: "total-count-display" };
const _hoisted_33 = {
    key: 0,
    class: "modal-overlay"
};
const _hoisted_34 = { class: "modal-window large-modal" };
const _hoisted_35 = { class: "modal-header" };
const _hoisted_36 = { class: "modal-title-group" };
const _hoisted_37 = { class: "icon-bg" };
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "modal-section-title" }, "Datos Fiscales e Identificación", -1 /* HOISTED */));
const _hoisted_39 = { class: "form-grid three-cols" };
const _hoisted_40 = { class: "form-group premium-input" };
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Tipo Doc.", -1 /* HOISTED */));
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "0",
    disabled: "",
    selected: ""
}, "Seleccione tipo...", -1 /* HOISTED */));
const _hoisted_43 = ["value"];
const _hoisted_44 = {
    key: 0,
    class: "error-text"
};
const _hoisted_45 = { class: "form-group premium-input" };
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Número de Documento", -1 /* HOISTED */));
const _hoisted_47 = ["placeholder"];
const _hoisted_48 = { class: "form-group premium-input" };
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Tipo Comercio", -1 /* HOISTED */));
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "0",
    disabled: "",
    selected: ""
}, "Seleccione comercio...", -1 /* HOISTED */));
const _hoisted_51 = ["value"];
const _hoisted_52 = {
    key: 0,
    class: "error-text"
};
const _hoisted_53 = { class: "form-grid" };
const _hoisted_54 = { class: "form-group premium-input" };
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Razón Social (Fiscal)", -1 /* HOISTED */));
const _hoisted_56 = { class: "form-group premium-input" };
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Firma Personal (Comercial)", -1 /* HOISTED */));
const _hoisted_58 = { class: "form-grid" };
const _hoisted_59 = { class: "form-group premium-input" };
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Tipo Contribuyente", -1 /* HOISTED */));
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "0",
    disabled: "",
    selected: ""
}, "Seleccione contribuyente...", -1 /* HOISTED */));
const _hoisted_62 = ["value"];
const _hoisted_63 = {
    key: 0,
    class: "error-text"
};
const _hoisted_64 = { class: "form-group premium-input" };
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "% Retención", -1 /* HOISTED */));
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "modal-section-title" }, "Ubicación y Dirección", -1 /* HOISTED */));
const _hoisted_67 = { class: "form-grid three-cols" };
const _hoisted_68 = { class: "form-group premium-input" };
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Estado", -1 /* HOISTED */));
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "0",
    disabled: "",
    selected: ""
}, "Seleccione estado...", -1 /* HOISTED */));
const _hoisted_71 = ["value"];
const _hoisted_72 = {
    key: 0,
    class: "error-text"
};
const _hoisted_73 = { class: "form-group premium-input" };
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Municipio", -1 /* HOISTED */));
const _hoisted_75 = ["disabled"];
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "0",
    disabled: "",
    selected: ""
}, "Seleccione municipio...", -1 /* HOISTED */));
const _hoisted_77 = ["value"];
const _hoisted_78 = {
    key: 0,
    class: "error-text"
};
const _hoisted_79 = { class: "form-group premium-input" };
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Parroquia", -1 /* HOISTED */));
const _hoisted_81 = ["disabled"];
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "0",
    disabled: "",
    selected: ""
}, "Seleccione parroquia...", -1 /* HOISTED */));
const _hoisted_83 = ["value"];
const _hoisted_84 = {
    key: 0,
    class: "error-text"
};
const _hoisted_85 = { class: "form-grid three-cols" };
const _hoisted_86 = { class: "form-group premium-input" };
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Ciudad", -1 /* HOISTED */));
const _hoisted_88 = { class: "form-group premium-input" };
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Sector", -1 /* HOISTED */));
const _hoisted_90 = { class: "form-group premium-input" };
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Dirección Corta", -1 /* HOISTED */));
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "modal-section-title" }, "Información de Contacto", -1 /* HOISTED */));
const _hoisted_93 = { class: "form-grid" };
const _hoisted_94 = { class: "form-group premium-input" };
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Celular Principal", -1 /* HOISTED */));
const _hoisted_96 = { class: "input-group" };
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "+58" }, "+58", -1 /* HOISTED */));
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "+1" }, "+1", -1 /* HOISTED */));
const _hoisted_99 = [
    _hoisted_97,
    _hoisted_98
];
const _hoisted_100 = { class: "form-group premium-input" };
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Celular Auxiliar", -1 /* HOISTED */));
const _hoisted_102 = { class: "input-group" };
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "+58" }, "+58", -1 /* HOISTED */));
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "+1" }, "+1", -1 /* HOISTED */));
const _hoisted_105 = [
    _hoisted_103,
    _hoisted_104
];
const _hoisted_106 = { class: "form-grid three-cols" };
const _hoisted_107 = { class: "form-group premium-input" };
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Teléfono Local 1", -1 /* HOISTED */));
const _hoisted_109 = { class: "input-group" };
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "+58" }, "+58", -1 /* HOISTED */));
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "+1" }, "+1", -1 /* HOISTED */));
const _hoisted_112 = [
    _hoisted_110,
    _hoisted_111
];
const _hoisted_113 = { class: "form-group premium-input" };
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Teléfono Local 2", -1 /* HOISTED */));
const _hoisted_115 = { class: "input-group" };
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "+58" }, "+58", -1 /* HOISTED */));
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "+1" }, "+1", -1 /* HOISTED */));
const _hoisted_118 = [
    _hoisted_116,
    _hoisted_117
];
const _hoisted_119 = { class: "form-group premium-input" };
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Correo Electrónico", -1 /* HOISTED */));
const _hoisted_121 = { class: "input-with-icon" };
const _hoisted_122 = { class: "modal-footer" };
const _hoisted_123 = {
    type: "submit",
    class: "btn-save-modal"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Header = _resolveComponent("Header");
    const _component_Sidebar = _resolveComponent("Sidebar");
    const _component_SearchIcon = _resolveComponent("SearchIcon");
    const _component_PlusIcon = _resolveComponent("PlusIcon");
    const _component_Loader2Icon = _resolveComponent("Loader2Icon");
    const _component_PowerIcon = _resolveComponent("PowerIcon");
    const _component_EditIcon = _resolveComponent("EditIcon");
    const _component_TrashIcon = _resolveComponent("TrashIcon");
    const _component_ChevronLeftIcon = _resolveComponent("ChevronLeftIcon");
    const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon");
    const _component_UserIcon = _resolveComponent("UserIcon");
    const _component_XIcon = _resolveComponent("XIcon");
    const _component_MailIcon = _resolveComponent("MailIcon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Sidebar),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _createVNode(_component_SearchIcon, {
                                    size: 18,
                                    class: "search-icon"
                                }),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.searchQuery) = $event)),
                                    placeholder: "Buscar por RIF o Razón Social...",
                                    class: "search-input"
                                }, null, 512 /* NEED_PATCH */), [
                                    [_vModelText, $setup.searchQuery]
                                ])
                            ])
                        ]),
                        ($setup.hasPermission('USER_CREATE'))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[1] || (_cache[1] = ($event) => ($setup.openModal())),
                                class: "btn btn-add"
                            }, [
                                _createVNode(_component_PlusIcon, { size: 18 }),
                                _hoisted_9
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("button", {
                                onClick: _cache[2] || (_cache[2] =
                                    //@ts-ignore
                                    (...args) => ($setup.resetFilter && $setup.resetFilter(...args))),
                                class: _normalizeClass([{ active: !$setup.selectedLetter }, "alphabet-button all-button"])
                            }, " Todos ", 2 /* CLASS */),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.alphabet, (letter) => {
                                return (_openBlock(), _createElementBlock("button", {
                                    key: letter,
                                    onClick: ($event) => ($setup.filterByLetter(letter)),
                                    class: _normalizeClass([{ active: $setup.selectedLetter === letter }, "alphabet-button"])
                                }, _toDisplayString(letter), 11 /* TEXT, CLASS, PROPS */, _hoisted_12));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("table", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("tbody", null, [
                            ($setup.isLoading)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                                    _createElementVNode("td", _hoisted_17, [
                                        _createElementVNode("div", _hoisted_18, [
                                            _createVNode(_component_Loader2Icon, {
                                                class: "spinner-icon text-primary",
                                                size: 32
                                            }),
                                            _hoisted_19
                                        ])
                                    ])
                                ]))
                                : ($setup.paginatedClientes.length === 0)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_20, _hoisted_22))
                                    : _createCommentVNode("v-if", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paginatedClientes, (item) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    key: item.clienteId
                                }, [
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", _hoisted_23, _toDisplayString($setup.getDocumentoFormateado(item)), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("td", _hoisted_24, _toDisplayString(item.nombreRazonSocial), 1 /* TEXT */),
                                    _createElementVNode("td", null, _toDisplayString(item.ciudad) + ", " + _toDisplayString(item.estadoNombre), 1 /* TEXT */),
                                    _createElementVNode("td", null, _toDisplayString(item.telCelular1 || 'N/A'), 1 /* TEXT */),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["status-badge", item.active ? 'active' : 'inactive'])
                                        }, _toDisplayString(item.active ? 'Activo' : 'Inactivo'), 3 /* TEXT, CLASS */)
                                    ]),
                                    _createElementVNode("td", _hoisted_25, [
                                        ($setup.hasPermission('USER_EDIT'))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                onClick: ($event) => ($setup.toggleActive(item)),
                                                class: "btn-icon btn-toggle",
                                                title: item.active ? 'Desactivar' : 'Activar'
                                            }, [
                                                _createVNode(_component_PowerIcon, {
                                                    size: 18,
                                                    class: _normalizeClass(item.active ? 'text-success' : 'text-danger')
                                                }, null, 8 /* PROPS */, ["class"])
                                            ], 8 /* PROPS */, _hoisted_26))
                                            : _createCommentVNode("v-if", true),
                                        ($setup.hasPermission('USER_EDIT'))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                onClick: ($event) => ($setup.openModal(item)),
                                                class: "btn-icon btn-edit",
                                                title: "Editar"
                                            }, [
                                                _createVNode(_component_EditIcon, { size: 18 })
                                            ], 8 /* PROPS */, _hoisted_27))
                                            : _createCommentVNode("v-if", true),
                                        ($setup.hasPermission('USER_DELETE'))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 2,
                                                onClick: ($event) => ($setup.confirmDelete(item.clienteId)),
                                                class: "btn-icon btn-delete",
                                                title: "Eliminar"
                                            }, [
                                                _createVNode(_component_TrashIcon, { size: 18 })
                                            ], 8 /* PROPS */, _hoisted_28))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("button", {
                        onClick: _cache[3] || (_cache[3] =
                            //@ts-ignore
                            (...args) => ($setup.prevPage && $setup.prevPage(...args))),
                        disabled: $setup.currentPage === 1,
                        class: "btn-pagination"
                    }, [
                        _createVNode(_component_ChevronLeftIcon, { size: 16 }),
                        _createTextVNode(" Anterior ")
                    ], 8 /* PROPS */, _hoisted_30),
                    _createElementVNode("span", null, [
                        _createTextVNode("Página "),
                        _createElementVNode("strong", null, _toDisplayString($setup.currentPage), 1 /* TEXT */),
                        _createTextVNode(" de "),
                        _createElementVNode("strong", null, _toDisplayString($setup.totalPages), 1 /* TEXT */)
                    ]),
                    _createElementVNode("button", {
                        onClick: _cache[4] || (_cache[4] =
                            //@ts-ignore
                            (...args) => ($setup.nextPage && $setup.nextPage(...args))),
                        disabled: $setup.currentPage === $setup.totalPages,
                        class: "btn-pagination"
                    }, [
                        _createTextVNode(" Siguiente "),
                        _createVNode(_component_ChevronRightIcon, { size: 16 })
                    ], 8 /* PROPS */, _hoisted_31)
                ]),
                _createElementVNode("div", _hoisted_32, " Total Clientes Registrados: " + _toDisplayString($setup.totalCount), 1 /* TEXT */),
                _createVNode(_Transition, { name: "modal-fade" }, {
                    default: _withCtx(() => [
                        ($setup.isModalOpen)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("div", _hoisted_35, [
                                        _createElementVNode("div", _hoisted_36, [
                                            _createElementVNode("div", _hoisted_37, [
                                                _createVNode(_component_UserIcon, {
                                                    size: 24,
                                                    class: "text-primary"
                                                })
                                            ])
                                        ]),
                                        _createElementVNode("button", {
                                            onClick: _cache[5] || (_cache[5] =
                                                //@ts-ignore
                                                (...args) => ($setup.closeModal && $setup.closeModal(...args))),
                                            class: "btn-close-modal"
                                        }, [
                                            _createVNode(_component_XIcon, { size: 24 })
                                        ])
                                    ]),
                                    _createElementVNode("form", {
                                        onSubmit: _cache[33] || (_cache[33] = _withModifiers(
                                        //@ts-ignore
                                        (...args) => ($setup.saveCliente && $setup.saveCliente(...args)), ["prevent"])),
                                        class: "modal-body"
                                    }, [
                                        _hoisted_38,
                                        _createElementVNode("div", _hoisted_39, [
                                            _createElementVNode("div", _hoisted_40, [
                                                _hoisted_41,
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => (($setup.form.tipoDocumentoId) = $event)),
                                                    onChange: _cache[7] || (_cache[7] =
                                                        //@ts-ignore
                                                        (...args) => ($setup.updateDocumentoPrefix && $setup.updateDocumentoPrefix(...args))),
                                                    class: _normalizeClass(["form-control-select", { 'input-error': $setup.formErrors.tipoDocumentoId }]),
                                                    required: ""
                                                }, [
                                                    _hoisted_42,
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.maestros.tiposDocumento, (doc) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: doc.tipoDocumentoId,
                                                            value: doc.tipoDocumentoId
                                                        }, _toDisplayString(doc.descripcion), 9 /* TEXT, PROPS */, _hoisted_43));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ], 34 /* CLASS, NEED_HYDRATION */), [
                                                    [_vModelSelect, $setup.form.tipoDocumentoId]
                                                ]),
                                                ($setup.formErrors.tipoDocumentoId)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_44, "Requerido"))
                                                    : _createCommentVNode("v-if", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_45, [
                                                _hoisted_46,
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => (($setup.form.documentoNumero) = $event)),
                                                    onInput: _cache[9] || (_cache[9] =
                                                        //@ts-ignore
                                                        (...args) => ($setup.cleanDocumento && $setup.cleanDocumento(...args))),
                                                    placeholder: $setup.placeholderDoc,
                                                    required: "",
                                                    class: "form-control no-icon"
                                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_47), [
                                                    [_vModelText, $setup.form.documentoNumero]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_48, [
                                                _hoisted_49,
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => (($setup.form.tipoComercioId) = $event)),
                                                    class: _normalizeClass(["form-control-select", { 'input-error': $setup.formErrors.tipoComercioId }]),
                                                    required: ""
                                                }, [
                                                    _hoisted_50,
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.maestros.tiposComercio, (tm) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: tm.tipoComercioId,
                                                            value: tm.tipoComercioId
                                                        }, _toDisplayString(tm.nombre), 9 /* TEXT, PROPS */, _hoisted_51));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ], 2 /* CLASS */), [
                                                    [_vModelSelect, $setup.form.tipoComercioId]
                                                ]),
                                                ($setup.formErrors.tipoComercioId)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_52, "Requerido"))
                                                    : _createCommentVNode("v-if", true)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_53, [
                                            _createElementVNode("div", _hoisted_54, [
                                                _hoisted_55,
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => (($setup.form.nombreRazonSocial) = $event)),
                                                    placeholder: "Nombre Fiscal",
                                                    required: "",
                                                    class: "form-control no-icon"
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.nombreRazonSocial]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_56, [
                                                _hoisted_57,
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => (($setup.form.nombreFirmaPersonal) = $event)),
                                                    placeholder: "Nombre del Negocio",
                                                    class: "form-control no-icon"
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.nombreFirmaPersonal]
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_58, [
                                            _createElementVNode("div", _hoisted_59, [
                                                _hoisted_60,
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => (($setup.form.tipoContribuyenteId) = $event)),
                                                    class: _normalizeClass(["form-control-select", { 'input-error': $setup.formErrors.tipoContribuyenteId }]),
                                                    required: ""
                                                }, [
                                                    _hoisted_61,
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.maestros.tiposContribuyente, (tc) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: tc.tipoContribuyenteId,
                                                            value: tc.tipoContribuyenteId
                                                        }, _toDisplayString(tc.nombre), 9 /* TEXT, PROPS */, _hoisted_62));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ], 2 /* CLASS */), [
                                                    [_vModelSelect, $setup.form.tipoContribuyenteId]
                                                ]),
                                                ($setup.formErrors.tipoContribuyenteId)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_63, "Requerido"))
                                                    : _createCommentVNode("v-if", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_64, [
                                                _hoisted_65,
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    step: "0.01",
                                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => (($setup.form.porcentajeRetencion) = $event)),
                                                    class: "form-control no-icon"
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.porcentajeRetencion]
                                                ])
                                            ])
                                        ]),
                                        _hoisted_66,
                                        _createElementVNode("div", _hoisted_67, [
                                            _createElementVNode("div", _hoisted_68, [
                                                _hoisted_69,
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => (($setup.form.estadoId) = $event)),
                                                    onChange: _cache[16] || (_cache[16] =
                                                        //@ts-ignore
                                                        (...args) => ($setup.onEstadoChange && $setup.onEstadoChange(...args))),
                                                    class: _normalizeClass(["form-control-select", { 'input-error': $setup.formErrors.estadoId }]),
                                                    required: ""
                                                }, [
                                                    _hoisted_70,
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.maestros.estados, (est) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: est.estadoId,
                                                            value: est.estadoId
                                                        }, _toDisplayString(est.nombre), 9 /* TEXT, PROPS */, _hoisted_71));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ], 34 /* CLASS, NEED_HYDRATION */), [
                                                    [_vModelSelect, $setup.form.estadoId]
                                                ]),
                                                ($setup.formErrors.estadoId)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_72, "Requerido"))
                                                    : _createCommentVNode("v-if", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_73, [
                                                _hoisted_74,
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => (($setup.form.municipioId) = $event)),
                                                    onChange: _cache[18] || (_cache[18] =
                                                        //@ts-ignore
                                                        (...args) => ($setup.onMunicipioChange && $setup.onMunicipioChange(...args))),
                                                    disabled: !$setup.form.estadoId,
                                                    class: _normalizeClass(["form-control-select", { 'input-error': $setup.formErrors.municipioId }]),
                                                    required: ""
                                                }, [
                                                    _hoisted_76,
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.maestros.municipios, (mun) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: mun.municipioId,
                                                            value: mun.municipioId
                                                        }, _toDisplayString(mun.nombre), 9 /* TEXT, PROPS */, _hoisted_77));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_75), [
                                                    [_vModelSelect, $setup.form.municipioId]
                                                ]),
                                                ($setup.formErrors.municipioId)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_78, "Requerido"))
                                                    : _createCommentVNode("v-if", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_79, [
                                                _hoisted_80,
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => (($setup.form.parroquiaId) = $event)),
                                                    disabled: !$setup.form.municipioId,
                                                    class: _normalizeClass(["form-control-select", { 'input-error': $setup.formErrors.parroquiaId }]),
                                                    required: ""
                                                }, [
                                                    _hoisted_82,
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.maestros.parroquias, (par) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: par.parroquiaId,
                                                            value: par.parroquiaId
                                                        }, _toDisplayString(par.nombre), 9 /* TEXT, PROPS */, _hoisted_83));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ], 10 /* CLASS, PROPS */, _hoisted_81), [
                                                    [_vModelSelect, $setup.form.parroquiaId]
                                                ]),
                                                ($setup.formErrors.parroquiaId)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_84, "Requerido"))
                                                    : _createCommentVNode("v-if", true)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_85, [
                                            _createElementVNode("div", _hoisted_86, [
                                                _hoisted_87,
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => (($setup.form.ciudad) = $event)),
                                                    placeholder: "Ciudad",
                                                    required: "",
                                                    class: "form-control no-icon"
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.ciudad]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_88, [
                                                _hoisted_89,
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => (($setup.form.sector) = $event)),
                                                    placeholder: "Sector",
                                                    required: "",
                                                    class: "form-control no-icon"
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.sector]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_90, [
                                                _hoisted_91,
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => (($setup.form.direccion) = $event)),
                                                    placeholder: "Calle/Carrera",
                                                    required: "",
                                                    class: "form-control no-icon"
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, $setup.form.direccion]
                                                ])
                                            ])
                                        ]),
                                        _hoisted_92,
                                        _createElementVNode("div", _hoisted_93, [
                                            _createElementVNode("div", _hoisted_94, [
                                                _hoisted_95,
                                                _createElementVNode("div", _hoisted_96, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => (($setup.form.telCelular1Prefix) = $event)),
                                                        class: "form-select prefix-select"
                                                    }, _hoisted_99, 512 /* NEED_PATCH */), [
                                                        [_vModelSelect, $setup.form.telCelular1Prefix]
                                                    ]),
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => (($setup.form.telCelular1Number) = $event)),
                                                        placeholder: "Número Celular",
                                                        required: "",
                                                        class: "form-control"
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelText, $setup.form.telCelular1Number]
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_100, [
                                                _hoisted_101,
                                                _createElementVNode("div", _hoisted_102, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => (($setup.form.telCelular2Prefix) = $event)),
                                                        class: "form-select prefix-select"
                                                    }, _hoisted_105, 512 /* NEED_PATCH */), [
                                                        [_vModelSelect, $setup.form.telCelular2Prefix]
                                                    ]),
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => (($setup.form.telCelular2Number) = $event)),
                                                        placeholder: "Opcional",
                                                        class: "form-control"
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelText, $setup.form.telCelular2Number]
                                                    ])
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_106, [
                                            _createElementVNode("div", _hoisted_107, [
                                                _hoisted_108,
                                                _createElementVNode("div", _hoisted_109, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => (($setup.form.telLocal1Prefix) = $event)),
                                                        class: "form-select prefix-select"
                                                    }, _hoisted_112, 512 /* NEED_PATCH */), [
                                                        [_vModelSelect, $setup.form.telLocal1Prefix]
                                                    ]),
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => (($setup.form.telLocal1Number) = $event)),
                                                        placeholder: "Número Local",
                                                        class: "form-control"
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelText, $setup.form.telLocal1Number]
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_113, [
                                                _hoisted_114,
                                                _createElementVNode("div", _hoisted_115, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event) => (($setup.form.telLocal2Prefix) = $event)),
                                                        class: "form-select prefix-select"
                                                    }, _hoisted_118, 512 /* NEED_PATCH */), [
                                                        [_vModelSelect, $setup.form.telLocal2Prefix]
                                                    ]),
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event) => (($setup.form.telLocal2Number) = $event)),
                                                        placeholder: "Opcional",
                                                        class: "form-control"
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelText, $setup.form.telLocal2Number]
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_119, [
                                                _hoisted_120,
                                                _createElementVNode("div", _hoisted_121, [
                                                    _createVNode(_component_MailIcon, {
                                                        size: 18,
                                                        class: "input-icon"
                                                    }),
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "email",
                                                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event) => (($setup.form.email) = $event)),
                                                        placeholder: "ejemplo@correo.com",
                                                        class: "form-control"
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelText, $setup.form.email]
                                                    ])
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_122, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                onClick: _cache[32] || (_cache[32] =
                                                    //@ts-ignore
                                                    (...args) => ($setup.closeModal && $setup.closeModal(...args))),
                                                class: "btn-cancel-modal"
                                            }, "Cancelar"),
                                            _createElementVNode("button", _hoisted_123, _toDisplayString($setup.isEditing ? 'Actualizar Cliente' : 'Registrar Cliente'), 1 /* TEXT */)
                                        ])
                                    ], 32 /* NEED_HYDRATION */)
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                })
            ])
        ])
    ]));
}
